import { IconSightMind } from "@resources/icons/Icons";
import { useLang } from "@hooks/useLang";
import * as S from "./MessageItem.styled";

const MessageItem = ({
  own,
  message,
  state
}: {
  own: boolean;
  message: string;
  state: string;
}) => {
  const { translate } = useLang();
  return (
    <S.Container own={own}>
      {!own ? (
        <>
          <S.MessageImgae>
            <IconSightMind width={28} height={26} />
          </S.MessageImgae>
          {state === "loading" ? (
            <S.MessageContentLoad>
              <p>{translate("loading")}</p>
              <S.MessageAILoading>
                <div />
                <div />
                <div />
                <div />
              </S.MessageAILoading>
            </S.MessageContentLoad>
          ) : (
            <S.MessageAIContent>{message}</S.MessageAIContent>
          )}
        </>
      ) : (
        <S.MessageUserContent>{message}</S.MessageUserContent>
      )}
    </S.Container>
  );
};

export default MessageItem;
